import { CardBtnArrowIcon } from '@jouzen/ecom-components/icons/CardBtnArrowIcon';
import {
  CarouselNavDirection,
  CarouselNavPagers,
} from '@jouzen/ecom-components/v4/Carousel';

import HeroCarouselNavPagerDot from './HeroCarouselNavPagerDot';

const directionClasses =
  'flex items-center justify-center size-4 text-sandstone-200 pt-px';

const Previous = () => {
  return (
    <CarouselNavDirection className={directionClasses} direction="backwards">
      <CardBtnArrowIcon className="scale-x-[-1]" width="10" />
    </CarouselNavDirection>
  );
};

const Next = () => {
  return (
    <CarouselNavDirection className={directionClasses} direction="forwards">
      <CardBtnArrowIcon width="10" />
    </CarouselNavDirection>
  );
};

const HeroCarouselNav = () => {
  return (
    <div className="absolute bottom-14 flex h-[18px] items-center gap-x-2 rounded-xl bg-gray-600/20 px-3 backdrop-blur-xs max-lg:left-1/2 max-lg:-translate-x-1/2 lg:right-6 lg:bottom-6 lg:px-1.5 xl:right-8 xl:bottom-8">
      <Previous />
      <CarouselNavPagers
        className="gap-x-2"
        CustomPagerDot={HeroCarouselNavPagerDot}
      />
      <Next />
    </div>
  );
};

export default HeroCarouselNav;
